module.exports = "/assets/9e16a5be33ee2a2f00cc650c8732297d.png";